require("./bootstrap");
require("select2");

import $ from "jquery";
import { popper } from "@popperjs/core";
import { Tooltip, Dropdown, Popover } from "bootstrap";
import { forEach, isEmpty, min } from "lodash";
NodeList.prototype.forEach = Array.prototype.forEach;
import autosize from "autosize";
global.autosize = autosize;

window.jQuery = window.$ = require("jquery");
const flatpickr = require("flatpickr");
require("autosize");
const French = require("flatpickr/dist/l10n/fr.js");

// const weekSelect = require("flatpickr/dist/plugins/weekSelect/weekSelect.js");

require("./form");
require("./messagerie");
require("./jquery.passtrength");

import * as Sentry from "@sentry/browser";
import { BrowserTracing } from "@sentry/tracing";
Sentry.init({
    dsn: "https://b45f091198cf45e98caad25419c5cd61@o141673.ingest.sentry.io/6363207",

    // Alternatively, use `process.env.npm_package_version` for a dynamic release version
    // if your build tool supports it.
    release: "repitaidant@1.0.0",
    integrations: [new BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

});

document.addEventListener("DOMContentLoaded", function () {

    // si repitAjouterModalOpen est défini, ouvrir la modal
    if (typeof repitAjouterModalOpen !== "undefined") {
        var $modal = $('#repitAjouterModal');

        // Ajoute les classes et attributs nécessaires
        $modal.addClass('show').css('display', 'block').attr('aria-modal', 'true').attr('role', 'dialog');

        // Crée un backdrop (le fond sombre)
        var $backdrop = $('<div class="modal-backdrop fade show"></div>');
        $('body').append($backdrop);

        // Gérer la fermeture via le bouton
        $modal.find('[data-bs-dismiss="modal"]').on('click', function() {
            $modal.removeClass('show').css('display', 'none').removeAttr('aria-modal role');
            $backdrop.remove();
        });
    }

    var popoverTriggerList = [].slice.call(
        document.querySelectorAll('[data-bs-toggle="popover"]')
    );
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new Popover(popoverTriggerEl);
    });

    var tooltipTriggerList = [].slice.call(
        document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new Tooltip(tooltipTriggerEl);
    });

    const messageries = document.querySelectorAll(
        ".messagerie .discussion_body"
    );
    const scrollToBottom = (node) => {
        node.scrollTop = node.scrollHeight;
    };
    messageries.forEach(function (element) {
        scrollToBottom(element);
    });

    log("Javascript loaded !!");
});

function log(message) {
    console.log("%c APP.JS >>> " + message, "background: #222; color: #bada55");
}

$(function () {
    $("form:not(#formLogin) #password").passtrength({
        minChars: 8,
        tooltip: true,
        textWeak: "Faible",
        textMedium: "Moyen",
        textStrong: "Fort",
        textVeryStrong: "Très Fort",
        passwordToggle: false,
    });

    $(".displayLoader").on("click", function (e) {
        $("#globalLoader").show();
    });
    $(".selectUserHeader").on("change", function () {
        var url = $(this).val(); // get selected value
        if (url != 0) {
            // require a URL
            $("#globalLoader").show();
            window.location = url; // redirect
        }
        return false;
    });
    $("#selectUserLogin").on("change", function () {
        var url = $(this).val(); // get selected value
        if (url != 0) {
            // require a URL
            $("#globalLoader").show();
            window.location = url; // redirect
        }
        return false;
    });

    const currentLang = $("body").data("lang");
    // console.log(Russian);
    // flatpickr.localize(Russian);
    var dispo_has_edit = false;

    // $(".select2").select2({dropdownParent: "#selectUserHeaderBody" });
    // $(".select2").select2();
    // $(".select2User").select2({dropdownParent: "#selectUserHeaderBody" });

    $(".select2").each(function (index) {
        var is_init = false;
        if ($(this).closest("#repitAjouterModalContent").length > 0) {
            $(this).select2({
                dropdownParent: $('#repitAjouterModalContent')
            });
            is_init = true;
        }
        if (!is_init && $(this).closest("#selectUserHeaderContent").length > 0) {
            $(this).select2({
                dropdownParent: $('#selectUserHeaderContent')
            });
            is_init = true;
        }
        if (!is_init) {
            $(this).select2();
        }
    });

    $('.select2city').select2({
        minimumInputLength: 3,
        ajax: {
            url: '/getvilles',
            dataType: 'json',
            language: "fr",
            data: function (params) {
                var query = {
                    s: params.term,
                }
                return query;
            }
        }
    });

    $(document).on('select2:open', function (e) {
        document.querySelector(`[aria-controls="select2-${e.target.id}-results"]`).focus();
    });
    $(".modal").on("shown.bs.modal", function () {
        // $(".select2").select2();
    });

    // $('.select2').each(function() {
    //     $(this).select2({ dropdownParent: $('#repitAjouterModal')});
    // })
    // $.fn.modal.Constructor.prototype.enforceFocus = function () {
    //     var that = this;
    //     $(document).on('focusin.modal', function (e) {
    //        if ($(e.target).hasClass('select2-input')) {
    //           return true;
    //        }

    //        if (that.$element[0] !== e.target && !that.$element.has(e.target).length) {
    //           that.$element.focus();
    //        }
    //     });
    //  };

    $(".datepicker").flatpickr({
        locale: currentLang,
        // altFormat: "Y-m-d",
        // dateFormat: "d/m/Y",
    });
    $(".datepicker-repit").flatpickr({
        static: true,
        enableTime: true,
        minDate: "today",
        time_24hr: true,
        minuteIncrement: 30,
        locale: currentLang,
        onReady: function (dateObj, dateStr, instance) {
            $('.flatpickr-time input').attr('disabled', 'disabled');
        }
        // altFormat: "Y-m-d",
        // dateFormat: "d/m/Y",
    });
    $(".datepicker-repit-fin").flatpickr({
        static: true,
        enableTime: false,
        minDate: "today",
        // time_24hr: true,
        // minuteIncrement: 30,
        locale: currentLang,
        // onReady: function (dateObj, dateStr, instance) {
        //     $('.flatpickr-time input').attr('disabled', 'disabled');
        // }
        // altFormat: "Y-m-d",
        // dateFormat: "d/m/Y",
    });
    $(".datepicker-hour").flatpickr({
        static: true,
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        minuteIncrement: 30,
        locale: currentLang,
    });
    $(".datepicker-expiration").flatpickr({
        // altFormat: "Y-m-d",
        // dateFormat: "d/m/Y",
        locale: currentLang,
        minDate: "today",
    });
    $(".datepicker-date_naissance").flatpickr({
        locale: currentLang,
        maxDate: "today",
        minDate: new Date(new Date().getFullYear() - 130, 0, 1),
    });
    $(".datepicker-date_naissance_travailleur").flatpickr({
        locale: currentLang,
        // Minimum 14 ans (date du jour - 14 ans)
        maxDate: new Date(new Date().setFullYear(new Date().getFullYear() - 14)),
        // Minimum 130 ans (date du jour - 130 ans)
        minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 130)),
    });
    if (typeof datepicker_dispo_dates !== "undefined") {
        const selectedDatesIds = $(".datepicker-dispo").data('selected-dates-ids');
        const selectedDatesIdsArray = (typeof selectedDatesIds === 'string') ? selectedDatesIds.split(",") : [];

        $(".datepicker-dispo").flatpickr({
            altFormat: "Y-m-d",
            dateFormat: "Y-m-d",
            inline: true,
            mode: "multiple",
            locale: currentLang,
            defaultDate: datepicker_dispo_dates,
            // showMonths: 4,
            onReady: function () {

                $('.flatpickr-day[tabindex=-1]').each(function (index) {
                    // console.log( index + ": " + $( this ).text() );
                    $(this).attr('data-day-id', index + 1);
                    if (selectedDatesIdsArray.includes($(this).text())) {
                        $(this).attr('data-dispo', 1);
                    }
                });
                window.addEventListener("beforeunload", function (e) {
                    // console.log($(e.explicitOriginalTarget).attr('type'));
                    if (
                        dispo_has_edit &&
                        e.target.activeElement.id != "submit_dispos"
                    ) {
                        e.preventDefault();
                        e.returnValue = "";
                    }
                    console.log(dispo_has_edit);
                });
                // window.onbeforeunload = confirmExit;
                // function confirmExit() {
                //     if(dispo_has_edit) {
                //         return "Avez-vous enregistré ?";
                //     }
                //     return null;
                // }
            },
            onChange: function (selectedDates, dateStr, instance) {
                $('.flatpickr-day[tabindex=-1]').each(function (index) {
                    // console.log( index + ": " + $( this ).text() );
                    $(this).attr('data-day-id', index + 1);
                    if (selectedDatesIdsArray.includes($(this).text())) {
                        $(this).attr('data-dispo', 1);
                    }
                });
                dispo_has_edit = true;
                const dateArr = selectedDates.map((date) =>
                    this.formatDate(date, "Y-m-d")
                );
                $(".date_dispo_div").each(function (index) {
                    if ($(this).is(":visible")) {
                        var to_hide = true;
                        for (var i in dateArr) {
                            if (
                                $(this).attr("id") ==
                                "date_dispo_" + dateArr[i]
                            ) {
                                to_hide = false;
                                break;
                            }
                        }
                        if (to_hide) {
                            $(this).fadeOut();
                        }
                    }
                });

                $(".date_remove").val(1);
                for (var i in dateArr) {
                    if ($("#date_dispo_" + dateArr[i]).is(":hidden")) {
                        $("#date_dispo_" + dateArr[i]).fadeIn();
                    }
                    $("#date_remove_" + dateArr[i]).val(0);
                }
            },
        });
    }
    $(".date_dispo_div .trash").off("click").on("click", function () {
        dispo_has_edit = true;
        var parent = $(this).closest(".date_dispo_div");
        var date_id = parent.attr("id").replace("date_dispo_", "");
        
        var confirm_text = datepicker_date_remove_confirm_text;
        if (
            confirm(
                confirm_text
            )
        ) {
            if (!parent.is(":hidden")) {
                parent.fadeOut();
            }
            $("#date_remove_" + date_id).val(1);
            var hor_div = parent.find(".horaires_div");
            hor_div.find(".time_dispo_div:not(:first)").remove();
            hor_div.find(".time_dispo_div:first .timepicker_start").val("");
            hor_div.find(".time_dispo_div:first .timepicker_end").val("");
            hor_div.find(".add_horaire_btn").show();
            hor_div.find(".remove_horaire_btn").hide();
            hor_div.find(".reset_horaire_btn").show();

            // récupérer l’instance flatpickr
            const fp = document.querySelector(".datepicker-dispo")._flatpickr;

            // enlever la date du calendrier
            fp.setDate(
                fp.selectedDates.filter(d => fp.formatDate(d, "Y-m-d") !== date_id),
                false // false = ne pas trigger onChange
            );




            
            // date_id est au format YYYY-MM-DD et je veux D le numéro du jour dans le mois sans le 0 initial
            var date_parts = date_id.split("-");
            var day_num = date_parts[2];
            // y a encore le 0 initial
            if (day_num.startsWith("0")) {
                day_num = day_num.substring(1);
            }
            console.log("day_num : " + day_num);
            // et deselect .flatpickr-day correspondant qui continent entre dans data-day-id le numéro du jour dans le mois
            $('.flatpickr-day[data-day-id="' + day_num + '"]').each(function (index) {
                console.log($(this));
                console.log(index + ": " + $(this).text());
                // supprimer attribut data-dispo="1"
                $(this).removeAttr('data-dispo');
                // suppression de la classe selected
                $(this).removeClass('selected');
            });
        }
    });

    $("input.timepicker").on("keyup change", function () {
        dispo_has_edit = true;
    });

    $(document).on('change', '#formDisposRecurrentes input', function (e) {
        e.preventDefault();
        $("#globalLoader").show();
        $('#formDisposRecurrentes').submit();
    });

    $(document).on('click', '.modalAlerteAnnulationBtn', function (e) {
        e.preventDefault();
        $('.modalAlerteAnnulation').hide();
        $('.modal-body').removeClass('is-blur');
        $('.modalAnnulationBtnHide').fadeIn();
    });
    $('.dispoRecurrenteCreneau').on('click', function () {
        var horaire = $(this).index();
        var btn = $(this).parents('.day').find('.ajaxModal');
        var heures = Math.floor(horaire / 2);
        var minutes = (Math.ceil(horaire / 2) - heures) * 30;
        btn.data('horaire', Array(heures + ':' + minutes, (heures + 2) + ':' + minutes));
        btn.trigger('click');

    });
    $('.disposViewMore').on('click', function (e) {
        e.preventDefault();
        $(this).closest('tr').hide();
        $(this).closest('.item_list').find('.dispoHide').fadeIn();
    });
    
    $(document).on("click", ":not(.disabled) .ajaxModal", function (e) {
        
        e.preventDefault();
        $("#globalLoader").show();
        var url = $(this).data("url");
        var target = $($(this).data("target"));
        var horaire = $(this).data("horaire");
        var is_horaire = true;
        if (horaire == undefined) {
            horaire = Array('12:00', '14:00');
            is_horaire = false;
        } else {
            url = url + "?h=1";
        }
        var btn = $(this);

        if (url && target && horaire) {
            $.ajax({
                url: url,
                type: "POST",
                headers: {
                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                        "content"
                    ),
                },
                success: function (response) {
                    $("#globalLoader").hide();
                    if (response.html) {
                        $("#globalLoader").hide();
                        target.find(".modal-content").html(response.html);
                        target.modal("show");

                        // $(".select2").select2({dropdownParent: "#ajaxModalContent" });
                        target.find(".modal-content .select2").each(function (index) {
                            $(this).select2({
                                dropdownParent: $('#ajaxModalContent')
                            });
                        });
                        // target.find(".select2").select2({
                        //     dropdownParent: $('#ajaxModal')
                        // });

                        if (is_horaire) {
                            $(".timepicker_start_new").flatpickr({
                                enableTime: true,
                                noCalendar: true,
                                dateFormat: "H:i",
                                defaultDate: horaire[0],
                                time_24hr: true,
                                minuteIncrement: 30,
                                disableMobile: "true",
                            });
                            $(".timepicker_end_new").flatpickr({
                                enableTime: true,
                                noCalendar: true,
                                dateFormat: "H:i",
                                defaultDate: horaire[1],
                                time_24hr: true,
                                minuteIncrement: 30,
                                disableMobile: "true",
                            });
                        }
                        $(".timepicker_start").flatpickr({
                            enableTime: true,
                            noCalendar: true,
                            dateFormat: "H:i",
                            // defaultDate: "12:00",
                            time_24hr: true,
                            minuteIncrement: 30,
                            disableMobile: "true",
                        });

                        $(".timepicker_end").flatpickr({
                            enableTime: true,
                            noCalendar: true,
                            dateFormat: "H:i",
                            // defaultDate: "14:00",
                            time_24hr: true,
                            minuteIncrement: 30,
                            disableMobile: "true",
                        });
                        target.find(".datepicker-repit").flatpickr({
                            static: true,
                            enableTime: true,
                            minDate: "today",
                            time_24hr: true,
                            minuteIncrement: 30,
                            locale: currentLang,
                            onReady: function (dateObj, dateStr, instance) {
                                $('.flatpickr-time input').attr('disabled', 'disabled');
                            }
                        });
                        /*
                        target.find(".datepicker-repit").flatpickr({
                            enableTime: true,
                            minDate: "today",
                            time_24hr: true,
                            minuteIncrement: 30,
                            locale: currentLang,
                            inline: true,
                            //defaultDate: "12:00",
                            // altFormat: "Y-m-d",
                            // dateFormat: "d/m/Y",
                        });*/
                        btn.data('horaire', '12');
                    }
                },
                error: function (response) {
                    $("#globalLoader").hide();
                },
            });
        }

    });
    
    $(document).on("click", ":not(.disabled) .htmlModal", function (e) {
        
        e.preventDefault();
        $("#globalLoader").show();

        var div = $($(this).data("id"));
        var modal = $($(this).data("target"));
        var btn = $(this);

        if (modal && div) {
            var html = div.html();
            $("#globalLoader").hide();
            $('#htmlModalContent').html(html);
            modal.modal("show");

            // $('#htmlModalContent [data-bs-toggle="tab"]').tab();
        }

    });

    $(document).on("click", ".demande_item, .demande_item td", function (e) {
        // e.preventDefault();
        if (
            e.target.tagName === "I" ||
            e.target.tagName === "A" ||
            e.target.tagName === "SPAN"
        )
            return;
        if ($(this).data("url")) {
            window.location.href = $(this).data("url");
        }
    });

    $(document).on("click", ".add_horaire_btn", function (e) {
        dispo_has_edit = true;
        e.preventDefault();
        var clone = $(this).closest(".time_dispo_div").clone();
        clone.find(".timepicker_start").val("");
        clone.find(".timepicker_end").val("");
        clone.appendTo($(this).closest(".horaires_div"));
        $(this)
            .closest(".horaires_div")
            .find(".time_dispo_div:not(:last) .add_horaire_btn")
            .hide();
        $(this)
            .closest(".horaires_div")
            .find(".time_dispo_div:not(:last) .remove_horaire_btn")
            .show();

        clone.find(".timepicker_start").flatpickr({
            enableTime: true,
            noCalendar: true,
            dateFormat: "H:i",
            defaultDate: "12:00",
            time_24hr: true,
            minuteIncrement: 30,
            disableMobile: "true",
        });
        clone.find(".timepicker_end").flatpickr({
            enableTime: true,
            noCalendar: true,
            dateFormat: "H:i",
            defaultDate: "14:00",
            time_24hr: true,
            minuteIncrement: 30,
            disableMobile: "true",
        });
    });
    $(document).on("click", ".remove_horaire_btn", function (e) {
        dispo_has_edit = true;
        e.preventDefault();
        $(this).closest(".time_dispo_div").remove();
        $(this)
            .closest(".horaires_div")
            .find(".time_dispo_div:not(:last) .add_horaire_btn")
            .hide();
        $(this)
            .closest(".horaires_div")
            .find(".time_dispo_div:not(:last) .remove_horaire_btn")
            .show();
        if ($('.time_dispo_div').length == 1) {
            $(".reset_horaire_btn").show();
        } else {
            $(".reset_horaire_btn").hide();
        }
    });
    $(document).on("click", ".reset_horaire_btn", function (e) {
        e.preventDefault();
        if ($(this).closest(".time_dispo_div").find(".timepicker_end_new")[0]) {
            $(this).closest(".time_dispo_div").find(".timepicker_end_new")[0].flatpickr().clear();
        }
        if ($(this).closest(".time_dispo_div").find(".timepicker_end")[0]) {
            $(this).closest(".time_dispo_div").find(".timepicker_end")[0].flatpickr().clear();
        }
        if ($(this).closest(".time_dispo_div").find(".timepicker_start_new")[0]) {
            $(this).closest(".time_dispo_div").find(".timepicker_start_new")[0].flatpickr().clear();
        }
        if ($(this).closest(".time_dispo_div").find(".timepicker_start")[0]) {
            $(this).closest(".time_dispo_div").find(".timepicker_start")[0].flatpickr().clear();
        }
    });
    $(document).on("change", ".timepicker_start", function (e) {
        var start = $(this).val();
        var date_start_init = new Date("2017-01-26 " + start);
        var date_start = new Date("2017-01-26 " + start);
        date_start.setHours(date_start.getHours() + 2);

        var hour = ("0" + date_start.getHours()).slice(-2);
        var minutes = ("0" + date_start.getMinutes()).slice(-2);

        if (date_start.getHours() >= 22) {
            hour = "23";
            minutes = "30";
        }
        var end = $(this)
            .closest(".time_dispo_div")
            .find(".timepicker_end")
            .val();
        console.log(end);
        var date_end = new Date("2017-01-26 " + end);
        if (date_end < date_start_init) {
            $(this)
                .closest(".time_dispo_div")
                .find(".timepicker_end")
                .flatpickr({
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: "H:i",
                    defaultDate: hour + ":" + minutes,
                    time_24hr: true,
                    minuteIncrement: 30,
                    disableMobile: "true",
                });
            $(this)
                .closest(".time_dispo_div")
                .find(".timepicker_end")
                .val(hour + ":" + minutes);
        }

        // console.log(hour);
        // console.log(minutes);
        // $(this).closest('.time_dispo_div').find('.timepicker_end').val(hour + ':' + minutes);
        // console.log($(this).closest('.time_dispo_div').find('.timepicker_end').flatpickr());
        // console.log($(this).closest('.timepicker_end'));

        // $(this).data('val', $(this).val());
        // $(this).data('val', 'sfrfzg');
    });

    $(".timepicker").flatpickr({
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        minuteIncrement: 30,
        disableMobile: "true",
    });

    $(".timepicker_start").flatpickr({
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        // defaultDate: "12:00",
        time_24hr: true,
        minuteIncrement: 30,
        disableMobile: "true",
    });

    $(".timepicker_end").flatpickr({
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        // defaultDate: "14:00",
        time_24hr: true,
        minuteIncrement: 30,
        disableMobile: "true",
    });

    if ($(".discussion_list .discussion_item a.current").length > 0) {
        $(".discussion_list").scrollTop(
            $(".discussion_item a.current").offset().top -
            $(".discussion_item a.current").parent().parent().offset().top -
            20
        );
    }

    document.addEventListener("visibilitychange", function () {
        sendRequestIsLog();
    });

    console.log("ready!");
});

function sendRequestIsLog() {
    $.ajax({
        url: "/islog",
        data: { islog: $("#inIsLog").val() },
        success: function (data) {
            // console.log(data)
            if (data.token !== undefined) {
                $('meta[name="csrf-token"]').attr("content", data.token);
            }
            if ($("#inIsLog").val() !== undefined && data.islog !== undefined) {
                if (parseInt($("#inIsLog").val()) !== parseInt(data.islog)) {
                    $("#globalLoader").show();
                    location.reload();
                }
            }
        },
        complete: function () {
            // Schedule the next request when the current one's
        },
    });
}
